import React from "react";
import { ReconRow } from "../types";
import { isEffectivelyZero, signedCcy } from "../helpers";

const Remarks: React.FC<{ row: ReconRow }> = ({ row }) => {
  if (row.match === "matched")
    return <span className="remarks zero">0.00</span>;
  if (row.match === "pending")
    return (
      <span
        className="remarks pending"
        title="No payments existed for this product and value date when it was reconciled. Rerun once they arrive."
      >
        No payments found
      </span>
    );

  const diff = row.diff || 0;

  // A mismatch can now come from an unattributed transaction rather than a
  // money difference. Printing 0.00 next to the missed count only muddies it,
  // so the count speaks for itself.
  if (isEffectivelyZero(diff)) return null;

  return (
    <span className={`remarks ${diff > 0 ? "pos" : "neg"}`}>
      {signedCcy(diff)}
    </span>
  );
};

export default Remarks;
